import { useLocation } from "wouter";

export function Footer() {
  const [location, navigate] = useLocation();
  const onHome = location === "/";

  // On home, smooth-scroll to the top; on any other route, navigate home
  // (client-side) and land at the top.
  const goHomeTop = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="relative bg-background border-t border-border py-12 overflow-hidden">
      {/* Nebula gradient overlays — static, CSS only */}
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 80% 90%, rgba(249,115,22,0.08), transparent 60%), radial-gradient(ellipse at 15% 10%, rgba(34,211,238,0.06), transparent 55%), linear-gradient(to bottom, transparent 80%, rgba(0,0,0,0.2))",
        }}
      />
      <div
        className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-6 relative"
        style={{ textShadow: "0 0 12px rgba(0,0,0,0.5)" }}
      >
        <a
          href="/"
          aria-label="Pax Magellanic — home"
          className="inline-flex items-center gap-3 group"
          onClick={goHomeTop}
        >
          <img
            src={`${import.meta.env.BASE_URL}assets/brand/mark-color.svg`}
            alt=""
            aria-hidden="true"
            className="h-10 w-10 md:h-11 md:w-11 select-none transition-transform duration-200 group-hover:scale-105"
            draggable={false}
          />
          <div className="flex flex-col leading-tight">
            <span
              className="text-base md:text-lg tracking-[0.06em] text-foreground select-none whitespace-nowrap"
              style={{ fontFamily: '"Major Mono Display", ui-monospace, Menlo, Consolas, monospace' }}
            >
              Pax Magellanic
            </span>
            <span className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground/80 mt-0.5 select-none">
              <span style={{ color: "#FFB860" }}>//</span> AI FOR BUSINESS
            </span>
          </div>
        </a>

        <div className="text-sm text-muted-foreground text-center md:text-left">
          &copy; 2026 Pax Magellanic. Boutique AI consulting, Houston, TX.
        </div>
      </div>
    </footer>
  );
}
